export default {
  isShrunk: false,
  hasUntrackedTags: false,
  hasUntrackedType: false
}
